export default {
	properties: [
		{
			text: 'Nombre',
			key: 'name',
			type: 'text',
		},
	],
	singular_model_name_spanish: 'Estado de lote de produccion',
	plural_model_name_spanish: 'Estados de lote de produccion',
	create_model_name_spanish: 'Nuevo Estado de lote de produccion',
	text_delete: 'el',
}